
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  public advList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            title: '舒适房间',
            desc: '每人一张3尺床铺，配备书桌、椅子、衣柜及独立冰箱，房间内设空调。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/sg_feature1.jpg'),
        },
        {
            id: 2,
            title: '共享厨房',
            desc: '每层设有Pantry及简易厨房，配备两个灶台及冰箱，满足日常烹饪需求。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/sg_feature2.jpg'),
        },
        {
            id: 3,
            title: '洗衣设备',
            desc: '每层设一部洗衣机，免费使用。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/sg_feature3.jpg'),
        },
        {
            id: 4,
            title: '顶楼天台',
            desc: '天台开放区域可供聚会、休憩及娱乐活动使用。',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/sg_feature4.jpg'),
        },
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            title: '舒適房間',
            desc: '每人一張3呎床鋪，配備書桌、椅子、衣櫥及獨立冰箱，房間內設冷氣。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/sg_feature1.jpg'),
        },
        {
            id: 2,
            title: '共享廚房',
            desc: '每層設有Pantry及簡易廚房，配備兩個灶台及冰箱，滿足日常烹飪需求。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/sg_feature2.jpg'),
        },
        {
            id: 3,
            title: '洗衣設備',
            desc: '每層設一部洗衣機，免費使用。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/sg_feature3.jpg'),
        },
        {
            id: 4,
            title: '頂樓天台',
            desc: '天台開放區域可供聚會、休憩及娛樂活動使用。',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/sg_feature4.jpg'),
        },
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            title: 'Comfortable room',
            desc: 'Each person has a 3-foot bed, equipped with a desk, chair, wardrobe and independent refrigerator. The room is equipped with air conditioning.',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/sg_feature1.jpg'),
        },
        {
            id: 2,
            title: 'Shared Kitchen',
            desc: 'Each floor has a Pantry and a simple kitchen, equipped with two stoves and a refrigerator to meet daily cooking needs.',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/sg_feature2.jpg'),
        },
        {
            id: 3,
            title: 'Laundry facilities',
            desc: 'Each floor is equipped with a washing machine, free of charge.',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/sg_feature3.jpg'),
        },
        {
            id: 4,
            title: 'Rooftop terrace',
            desc: 'The open area of ​​the rooftop can be used for gatherings, relaxation and entertainment activities.',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/sg_feature4.jpg'),
        },
      ]
    }
  ];
  public roomTypeList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            roomType: '單人房',
            desc: '精致单人空间，共享客厅226尺',
            roomSize: '120呎',
            roomHeight: '3.2米层高',
            roomPeople: '1人',
            roomPrice: 'SGD 1,999 起/每人',
            roomList : [
              {
                id: 1,
                name: '1房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 2,
                name: '2房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 3,
                name: '3房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 4,
                name: '4房',
                videoUrl: require('@/assets/image/common/sg_RM4.mp4'),
              },
              {
                id: 5,
                name: '5房',
                videoUrl: require('@/assets/image/common/sg_RM5.mp4'),
              },
              {
                id: 6,
                name: '6房',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              },
              {
                id: 7,
                name: '7房',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/sg_room1.jpg'),
        },
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            roomType: '單人房',
            desc: '精緻單人空間，共享客廳226呎',
            roomSize: '120呎',
            roomHeight: '3.2米層高',
            roomPeople: '1人',
            roomPrice: 'SGD 1,999 起/每人',
            roomList : [
              {
                id: 1,
                name: '1房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 2,
                name: '2房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 3,
                name: '3房',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 4,
                name: '4房',
                videoUrl: require('@/assets/image/common/sg_RM4.mp4'),
              },
              {
                id: 5,
                name: '5房',
                videoUrl: require('@/assets/image/common/sg_RM5.mp4'),
              },
              {
                id: 6,
                name: '6房',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              },
              {
                id: 7,
                name: '7房',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/sg_room1.jpg'),
        },
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            roomType: 'Single',
            desc: 'Exquisite single space, shared living room 226 square feet',
            roomSize: '120 feet',
            roomHeight: '3.2m height',
            roomPeople: '1 person',
            roomPrice: 'From SGD 1,999/person',
            roomList : [
              {
                id: 1,
                name: 'Room 1',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 2,
                name: 'Room 2',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 3,
                name: 'Room 3',
                videoUrl: require('@/assets/image/common/sg_RM3.mp4'),
              },
              {
                id: 4,
                name: 'Room 4',
                videoUrl: require('@/assets/image/common/sg_RM4.mp4'),
              },
              {
                id: 5,
                name: 'Room 5',
                videoUrl: require('@/assets/image/common/sg_RM5.mp4'),
              },
              {
                id: 6,
                name: 'Room 6',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              },
              {
                id: 7,
                name: 'Room 7',
                videoUrl: require('@/assets/image/common/sg_RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/sg_room1.jpg'),
        },
      ]
    }
  ];
  public locationList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            university: 'James Cook University',
            time: '约8分钟',
        },
        {
            id: 2,
            university: 'ERC Institute',
            time: '约17分钟',
        },
        {
            id: 3,
            university: 'Kaplan',
            time: '约18分钟',
        },
        {
            id: 4,
            university: 'PSB Academy',
            time: '约27分钟',
        },
        {
            id: 5,
            university: 'Singapore Management University',
            time: '约27分钟',
        },
        {
            id: 6,
            university: 'Management Development Institute of Singapore',
            time: '约36分钟',
        },
        {
            id: 7,
            university: 'Curtin',
            time: '约40分钟',
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            university: 'James Cook University',
            time: '約8分鐘',
        },
        {
            id: 2,
            university: 'ERC Institute',
            time: '約17分鐘',
        },
        {
            id: 3,
            university: 'Kaplan',
            time: '約18分鐘',
        },
        {
            id: 4,
            university: 'PSB Academy',
            time: '約27分鐘',
        },
        {
            id: 5,
            university: 'Singapore Management University',
            time: '約27分鐘',
        },
        {
            id: 6,
            university: 'Management Development Institute of Singapore',
            time: '約36分鐘',
        },
        {
            id: 7,
            university: 'Curtin',
            time: '約40分鐘',
        }
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            university: 'James Cook University',
            time: 'About 8 minutes',
        },
        {
            id: 2,
            university: 'ERC Institute',
            time: 'About 17 minutes',
        },
        {
            id: 3,
            university: 'Kaplan',
            time: 'About 18 minutes',
        },
        {
            id: 4,
            university: 'PSB Academy',
            time: 'About 27 minutes',
        },
        {
            id: 5,
            university: 'Singapore Management University',
            time: 'About 27 minutes',
        },
        {
            id: 6,
            university: 'Management Development Institute of Singapore',
            time: 'About 36 minutes',
        },
        {
            id: 7,
            university: 'Curtin',
            time: 'About 40 minutes',
        }
      ]
    }
  ];
  public locationDescList = [
    {
      lang: 'zh',
      desc1: '走路3分钟至 Lavender（劳明达）地铁站',
      desc2: '走路5分钟至移民厅',
      desc3: '购物生活方便，临近超市，食阁，大型商场，地铁巴士站。项目一楼为网咖(Cyber Cafe)'
    },
    {
      lang: 'zh-hk',
      desc1: '步行3分鐘至 Lavender（勞明達）地鐵站',
      desc2: '走路5分鐘至移民廳',
      desc3: '購物生活方便，接近超市，食閣，大型商場，地鐵巴士站。專案一樓為網咖(Cyber​​ Cafe)'
    },
    {
      lang: 'en-us',
      desc1: '3-minute walk to Lavender MRT Station',
      desc2: '5-minute walk to Immigration Department',
      desc3: 'Convenient shopping and living, close to supermarkets, food courts, large shopping malls, and MRT and bus stations. There\'s also a cyber cafe on the first floor.'
    },
  ];
  public feeDescList = [
    {
      lang: 'zh',
      desc1: '水電每月結算並均分（不含網絡），退租須提前30天通知，',
      desc2: '家电家具自然损坏免费维修，人为损坏需赔偿，押金于退租后14日内退还。'
    },
    {
      lang: 'zh-hk',
      desc1: '水電每月結算並均分（不含網路），退租須提前30天通知，',
      desc2: '家電家具自然損壞免費維修，人為損壞需賠償，押金於退租後14日內退還。'
    },
    {
      lang: 'en-us',
      desc1: 'Utilities are billed monthly and split equally (internet excluded). 30 days\' notice is required for termination.',
      desc2: 'Natural damage to appliances and furniture is free of charge. Damage caused by human error will incur a charge. The deposit is refundable within 14 days of termination.'
    }
  ];
  public contactInfo = [
    {
      lang: 'zh',
      address: '30 Penhas Road',
      phone: '+65 9129 9187',
      email: 'info@prestige32.com'
    },
    {
      lang: 'zh-hk',
      address: '30 Penhas Road',
      phone: '+65 9129 9187',
      email: 'info@prestige32.com'
    },
    {
      lang: 'en-us',
      address: '30 Penhas Road',
      phone: '+65 9129 9187',
      email: 'info@prestige32.com'
    }
  ];
  public showRoomVisit = false;
  public roomList = [];
  public roomSelected = 0;
  public roomVideo = '';
  public getAdvList() {
    return this.advList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getRoomTypeList() {
    return this.roomTypeList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getLocationList() {
    return this.locationList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getLocationDescList() {
    return this.locationDescList.find((item: any)=>item.lang === AppModule.language);
  }
  public getFeeDescList() {
    if (this.feeDescList.length > 0) {
        return this.feeDescList.find((item: any)=>item.lang === AppModule.language);
    }
    return null;
  }
  public getContactInfo() {
    return this.contactInfo.find((item: any)=>item.lang === AppModule.language);
  }
  public mounted() {
    const roomTypeData = this.roomTypeList.find((item: any)=>item.lang === AppModule.language)?.data;
    if (roomTypeData) {
      this.roomSelected = roomTypeData[0].roomList[0].id;
      this.roomVideo = roomTypeData[0].roomList[0].videoUrl;
    }
  }
  public goRoomVisit(item: any) {
    this.showRoomVisit = true;
    this.roomList = item.roomList;
  }
  public closeRoomVisit() {
    this.showRoomVisit = false;
  }
  public setRoomVideo(item: any) {
    this.roomVideo = item.videoUrl;
    this.roomSelected = item.id;
  }
}
